import { FC, useEffect, useMemo } from "react";
import { Typography } from "theme";

import { Box, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useBooking } from "../../../../utils/context/Booking/BookingContext.tsx";

const StyledImage = styled("img")(({ theme }) => {
  return {
    height: "56px",
    width: "56px",
    objectFit: "contain",
    backgroundColor: theme.palette.common.white,
  };
});


const SelectedEquipment:FC<{
  setEquipmentPrice: (price: number) => void;
}> = ({ setEquipmentPrice }) => {
  const { equipment } = useBooking();

  const total = useMemo(() => equipment?.equipment.reduce((accumulator, currentItem) => {
    return accumulator + (currentItem.count * (currentItem.isFixedPrice ? 1 : (currentItem.range > 3 ? 3 : currentItem.range)) * currentItem.pricePerUnit);
  }, 0), [equipment?.equipment]);

  useEffect(() => {
    if (total){
      setEquipmentPrice(total)
    }
  }, [setEquipmentPrice, total]);

  if (!equipment) return null;

  return (
    <Box>
      <Grid2 mb={1.25} container justifyContent='space-between' alignItems='center'>
        <Typography variant="body1" weight="regular">
          Вартість обладнання:
        </Typography>
        <Typography variant="body1" weight="semiBold">
          {total} грн.
        </Typography>
      </Grid2>
      {equipment.equipment.map(eq => (
        <Grid2 key={eq.id} container columnGap={1.5} mb={1.5}>
          <Box>
            <StyledImage src={eq.imageUrl || ''} />
          </Box>
          <Box>
            <Typography mb={0.5} variant="body1" weight="semiBold" textTransform="uppercase">
              {eq.title}
            </Typography>

            <Grid2 container columnGap={1.5} alignItems='center'>
              <Typography my={0.5} variant="body1" weight="regular">
                Кількість: {eq.count}
              </Typography>

              <Typography variant="body1" weight="semiBold" textTransform="uppercase">
                {eq.pricePerUnit} {eq.isFixedPrice ? 'грн' : 'грн/год'}
              </Typography>
            </Grid2>

            <Typography my={0.5} variant="body1" weight="regular">
              Тривалість: {eq.range} год
            </Typography>
          </Box>
        </Grid2>
      ))}
    </Box>
  );
};

export default SelectedEquipment;
